import { createFileRoute } from '@tanstack/react-router'
import { CeremonySectionPage } from '@/features/setup/ceremony-section-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/setup/ceremony')({
  component: CeremonySectionRoute,
})

function CeremonySectionRoute() {
  const { workspaceSlug } = Route.useParams()

  return <CeremonySectionPage workspaceSlug={workspaceSlug} />
}
